import { render, staticRenderFns } from "./OAutoBackup.vue?vue&type=template&id=a735b7f4&scoped=true&"
import script from "./OAutoBackup.vue?vue&type=script&lang=js&"
export * from "./OAutoBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a735b7f4",
  null
  
)

export default component.exports